import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import { auth as authCore } from '@breezeway/brzw-react-core';

import datastoreConstants from '@datastore/constants';
import datastoreReducer from '@datastore/reducer';

import internalConstants from '@internalStore/constants';
import internalReducer from '@internalStore/reducer';

import applicationConstants from './app/constants';
import applicationReducer from './app/reducer';

import adminConstants from './admin/constants';
import adminReducer from './admin/reducer';

import dashboardConstants from './dashboard/constants';
import dashboardReducer from './dashboard/reducer';
import dashboardReducerV2 from './dashboard/reducerV2';

import messengerConstants from './messenger/constants';
import messengerReducer from './messenger/reducer';

import notificationsConstants from './notifications/constants';
import notificationsReducer from './notifications/reducer';

import propertyConstants from './property/constants';
import propertyReducer from './property/reducer';

import propertyListConstants from './property_list/constants';
import propertyListReducer from './property_list/reducer';

import repConstants from './rep/constants';
import repReducer from './rep/reducer';

import reservationConstants from './reservation/constants';
import reservationReducer from './reservation/reducer';

import scheduleConstants from './schedule/constants';
import scheduleReducer from './schedule/reducer';

import taskConstants from './task/constants';
import taskReducer from './task/reducer';

import taskListConstants from './task_list/constants';
import taskListReducer from './task_list/reducer';

import taskTemplateConstants from './task_template/constants';
import taskTemplateReducer from './task_template/reducer';

const appReducer = combineReducers({
  form,
  routing: routerReducer,
  [adminConstants.NAME]: adminReducer,
  [applicationConstants.NAME]: applicationReducer,
  [dashboardConstants.NAME]: dashboardReducer,
  [dashboardConstants.NAME_V2]: dashboardReducerV2,
  [datastoreConstants.NAME]: datastoreReducer,
  [internalConstants.NAME]: internalReducer,
  [messengerConstants.NAME]: messengerReducer,
  [notificationsConstants.NAME]: notificationsReducer,
  [propertyConstants.NAME]: propertyReducer,
  [propertyListConstants.NAME]: propertyListReducer,
  [repConstants.NAME]: repReducer,
  [reservationConstants.NAME]: reservationReducer,
  [scheduleConstants.NAME]: scheduleReducer,
  [taskConstants.NAME]: taskReducer,
  [taskListConstants.NAME]: taskListReducer,
  [taskTemplateConstants.NAME]: taskTemplateReducer,
});

const rootReducer = (state, action) => {
  if (action.type === authCore.actionTypes.SIGNOUT_USER) {
    /* eslint-disable no-param-reassign */
    state = {
      datastore: {
        types: state.datastore.types,
      },
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
